
import React from 'react';
import Feature from 'ol/Feature'
import get from 'lodash/get';

import createInteractionInfo from '../../openlayers/interactionMapToolInfo';
import createInteractionDrawLine from '../../openlayers/interactionMapToolDrawLine';
import createInteractionDrawPoint from '../../openlayers/interactionMapToolDrawPoint';
import createInteractionDrawPolygon from '../../openlayers/interactionMapToolDrawPolygon';
import createInteractionMeasureLine from '../../openlayers/interactionMapToolMeasureLine';
import createInteractionMeasurePoint from '../../openlayers/interactionMapToolMeasurePoint';
import createInteractionMeasurePolygon from '../../openlayers/interactionMapToolMeasurePolygon';
import createInteractionMeasureModify from '../../openlayers/interactionMapToolMeasureModify';
import createInteractionModifyFeature from '../../openlayers/interactionMapToolModifyFeature';
import createInteractionKn from '../../openlayers/interactionMapToolKn';
import { styleFunction } from '../../openlayers/measureStyle';

import { getTools } from '../../reducers/map';

import { ContainerWithToolbar, ToolbarSeparator } from '../../../core';
import MapBase from './MapBase';
import ButtonCommandZoomIn from './ButtonCommandZoomIn';
import ButtonCommandZoomOut from './ButtonCommandZoomOut';
import ButtonCommandZoomDefault from './ButtonCommandZoomDefault';
import ButtonCommandTools from './ButtonCommandTools';

class MapInContainer extends React.Component {

    constructor(props) {
        super(props);
        this._mapComponent = null;
    }

    getMapTools = () => {
        const options = {
            nahlizeniDoKn: get(this.props.appConfig, 'map.tools.nahlizeniDoKn')
        };
        return getTools(this.props.map, options);
    }

    getOlMap() {
        return this._mapComponent.getOlMap();
    }

    handleMapToolExecute = (toolId, params) => {
        switch (toolId) {
            case 'Info':
                // nop;
                break;
            case 'DrawPoint':
            case 'DrawLine':
            case 'DrawPolygon':
                this.props.mapActions.addCommand(
                    'SET_TEMP_FEATURE',
                    {
                        features: [params.feature]
                    }
                );
                this.props.mapActions.setTempFeature(params.feature.clone());
                break;
            case 'MeasurePoint':
            case 'MeasureLine':
            case 'MeasurePolygon':
                switch (params.action) {
                    case 'measureend':
                        this.processMeasureEnd(params);
                        break;
                    case 'measureupdated':
                        this.processMeasureUpdated(params);
                        break;
                }
                break;
            case 'MeasureModify':
                this.processMeasureModify(params);
                break;
            case 'ModifyFeature':
                this.props.mapActions.setTempFeature(params.feature.clone());
                break;
            default:
                // nop;
                break;
        }
    }

    getMeasureItem = (values) => {
        return {
            id: values.id,
            type: '2D',
            values: values,
        };
    }

    processMeasureEnd = (params) => {
        this.props.appActions.setUiValue('activePanelName', 'measurement');
        this.props.measurementActions.setMeasureInList(this.getMeasureItem(params.values));

        let measureLayer = this.getOlMap().getMeasureLayer();
        let geometry = params.geometry.clone();
        geometry.ol_uid = params.geometry.ol_uid;
        let feature = new Feature({
            geometry
        });
        feature.setStyle(styleFunction);
        measureLayer.getSource().addFeature(feature);
    }

    processMeasureModify = (params) => {
        this.props.appActions.setUiValue('activePanelName', 'measurement');
        this.props.measurementActions.setMeasureInList(this.getMeasureItem(params.values));
    }

    processMeasureUpdated = (params) => {
        this.props.appActions.setUiValue('activePanelName', 'measurement');
        this.props.measurementActions.setMeasureValues(params.values);
    }

    handleSelectTool = (toolId, tool) => {

        let measurementTool = null;

        switch (toolId) {
            case 'MeasurePoint':
            case 'MeasureLine':
            case 'MeasurePolygon':
            case 'MeasureMeasure':
                measurementTool = {
                    title: tool.title
                };
                break;
            default:
                break;
        }

        this.props.measurementActions.setMeasureTool(measurementTool);

        this.props.mapActions.addCommand(
            'SET_MAP_TOOL',
            {
                toolId: toolId
            }
        );
    }

    render() {
        const mapButtons = [
            <ButtonCommandZoomIn/>,
            <ButtonCommandZoomOut/>,
            <ButtonCommandZoomDefault/>,
            <ToolbarSeparator />,
            <ButtonCommandTools
                tools={this.getMapTools()}
                onSelectTool={this.handleSelectTool}
            />
        ];

        const olInteractions = [
            [
                createInteractionInfo,
                {
                    onFeatureClick: this.props.onFeatureClick,
                    onFeaturesFind: this.props.onFeaturesFind,
                    onMapToolExecute: this.handleMapToolExecute,
                    onShowMessage: this.props.onShowMessage
                }
            ],
            createInteractionDrawLine,
            createInteractionDrawPoint,
            createInteractionDrawPolygon,
            createInteractionMeasureLine,
            createInteractionMeasurePoint,
            createInteractionMeasurePolygon,
            createInteractionMeasureModify,
            createInteractionModifyFeature,
            createInteractionKn
        ];

        return (
            <ContainerWithToolbar toolbarPosition="right" toolbarDirection="" buttons={mapButtons}>
                <MapBase
                    ref={element => this._mapComponent = element}
                    appConfig={this.props.appConfig}
                    map={this.props.map}
                    layers={this.props.map.layers}
                    groups={this.props.map.groups}
                    mapLayersDefinition={this.props.mapLayersDefinition}
                    moduleActions={this.props.mapActions}
                    toolsMode={this.props.toolsMode}
                    olInteractions={olInteractions}
                    onChangeView={this.props.onChangeView}
                    onFeatureClick={this.props.onFeatureClick}
                    onFeaturesFind={this.props.onFeaturesFind}
                    onMapToolExecute={this.handleMapToolExecute}
                    onShowMessage={this.props.onShowMessage}
                />
            </ContainerWithToolbar>
        );
    }

    updateSize() {
        this._mapComponent.updateSize();
    }
}

export default MapInContainer;
